import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  style: {"line-height":"20px !important"},
  "nav-title": ""
}
const _hoisted_2 = {
  key: 0,
  style: {"padding-right":"6px"},
  "m-tb-0": ""
}
const _hoisted_3 = { style: {"min-height":"60vh"} }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "App-Opportunity-D" }
const _hoisted_6 = {
  class: "App-Opportunity-D-T",
  "m-t-1": "",
  "m-b-2": ""
}
const _hoisted_7 = {
  "txt-center": "",
  "m-tb-0": ""
}
const _hoisted_8 = {
  dark: "",
  "f-w-700": ""
}
const _hoisted_9 = {
  key: 0,
  "txt-center": "",
  "f-w-600": "",
  "m-tb-0": ""
}
const _hoisted_10 = {
  "m-tb-10px": "",
  "txt-center": "",
  primary: ""
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "App-Opp-Star-C" }
const _hoisted_13 = {
  key: 0,
  class: "App-Opp-Star-C-B"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_left_nav = _resolveComponent("app-left-nav")!
  const _component_app_bottom_nav = _resolveComponent("app-bottom-nav")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_app_top_nav = _resolveComponent("app-top-nav")!
  const _component_OpportunityPageHeader = _resolveComponent("OpportunityPageHeader")!
  const _component_app_startup_opp = _resolveComponent("app-startup-opp")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_app_section_divider = _resolveComponent("app-section-divider")!
  const _component_OpportunityPageDetails = _resolveComponent("OpportunityPageDetails")!
  const _component_app_truncate = _resolveComponent("app-truncate")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_OpportunityUsersList = _resolveComponent("OpportunityUsersList")!
  const _component_OpportunityUpdateModal = _resolveComponent("OpportunityUpdateModal")!
  const _component_app_business_right_nav = _resolveComponent("app-business-right-nav")!
  const _component_app_user_right_intro = _resolveComponent("app-user-right-intro")!
  const _component_app_opportunities_list_nav = _resolveComponent("app-opportunities-list-nav")!
  const _component_app_right_nav = _resolveComponent("app-right-nav")!
  const _component_app_main_layout = _resolveComponent("app-main-layout")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_app_main_layout, { class: "App-Opportunity-Page" }, {
    left: _withCtx(() => [
      _createVNode(_component_app_left_nav)
    ]),
    "bottom-nav": _withCtx(() => [
      _createVNode(_component_app_bottom_nav)
    ]),
    top: _withCtx(() => [
      _createVNode(_component_app_top_nav, { padded: false }, _createSlots({
        left: _withCtx(() => [
          false
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "text",
                plain: "",
                circle: "",
                "is-all-borderless": "",
                icon: "el-icon-back"
              }))
            : _createCommentVNode("", true)
        ]),
        center: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, [
            (_ctx.opportunity !== undefined)
              ? (_openBlock(), _createElementBlock("h4", _hoisted_2, _toDisplayString(_ctx.opportunity.outcome), 1))
              : _createCommentVNode("", true),
            _cache[0] || (_cache[0] = _createElementVNode("div", null, [
              _createElementVNode("span", {
                "mute-secondary": "",
                style: {"font-weight":"500","font-size":"14px"}
              }, " Opportunity ")
            ], -1))
          ])
        ]),
        _: 2
      }, [
        (_ctx.opportunity !== undefined && _ctx.user)
          ? {
              name: "right",
              fn: _withCtx(() => [
                (_ctx.user.type === 'founder')
                  ? (_openBlock(), _createBlock(_component_el_dropdown, {
                      key: 0,
                      onCommand: _ctx.handleCommand
                    }, {
                      dropdown: _withCtx(() => [
                        _createVNode(_component_el_dropdown_menu, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_dropdown_item, {
                              command: "edit",
                              icon: "el-icon-edit"
                            }, {
                              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                _createTextVNode(" Edit ", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          icon: "el-icon-more",
                          round: ""
                        })
                      ]),
                      _: 1
                    }, 8, ["onCommand"]))
                  : _createCommentVNode("", true)
              ]),
              key: "0"
            }
          : undefined
      ]), 1024)
    ]),
    middle: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
        (_ctx.opportunity !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", null, [
                (_ctx.business)
                  ? (_openBlock(), _createBlock(_component_OpportunityPageHeader, {
                      key: 0,
                      business: _ctx.business,
                      opportunity: _ctx.opportunity
                    }, null, 8, ["business", "opportunity"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("p", _hoisted_7, [
                      _cache[2] || (_cache[2] = _createTextVNode(" Looking For ", -1)),
                      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.opportunity.talents) + " Talent(s)", 1)
                    ]),
                    (Array.isArray(_ctx.opportunity.skill))
                      ? (_openBlock(), _createElementBlock("h3", _hoisted_9, [
                          _cache[3] || (_cache[3] = _createElementVNode("span", { "mute-secondary": "" }, "In ", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.$filters.capitalize(_ctx.opportunity.skill[0])) + " / " + _toDisplayString(_ctx.$filters.capitalize(_ctx.opportunity.skill[1])), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.opportunity.outcome), 1)
                  ]),
                  _createVNode(_component_app_startup_opp, { business: _ctx.business }, null, 8, ["business"]),
                  (_ctx.opportunity.regionFilter)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_el_divider),
                          _createVNode(_component_el_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_12, [
                                    _cache[4] || (_cache[4] = _createElementVNode("div", {
                                      class: "App-Opp-Star-C-S",
                                      "mute-secondary": ""
                                    }, " Looking for talents from ", -1)),
                                    (_ctx.opportunity.regionFilter.options)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.opportunity.regionFilter.options
                              .map((c) => _ctx.$filters.capitalize(c))
                              .join(", ")), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_app_section_divider),
                  _createVNode(_component_el_space, {
                    direction: "vertical",
                    alignment: "flex-start",
                    size: 16
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_OpportunityPageDetails, {
                        opportunity: _ctx.opportunity,
                        business: _ctx.business
                      }, null, 8, ["opportunity", "business"]),
                      _createVNode(_component_app_truncate, {
                        style: {"font-size":"14px"},
                        content: _ctx.opportunity.description,
                        max: 4000,
                        "m-tb-0": ""
                      }, null, 8, ["content"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              (_ctx.opportunity !== undefined && _ctx.user.type === 'founder')
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createVNode(_component_OpportunityUsersList, {
                      showHeader: false,
                      showLink: false,
                      opportunity: _ctx.opportunity
                    }, null, 8, ["opportunity"]),
                    _createVNode(_component_OpportunityUpdateModal, {
                      onClosed: _ctx.stopUpdateOpportunity,
                      opportunity: _ctx.opportunity,
                      isModalOpen: _ctx.isEditing,
                      onUpdate: _ctx.opportunityFetch
                    }, null, 8, ["onClosed", "opportunity", "isModalOpen", "onUpdate"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    right: _withCtx(() => [
      _createVNode(_component_app_right_nav, null, {
        default: _withCtx(() => [
          (_ctx.user.type === 'founder')
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(_component_app_business_right_nav)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createVNode(_component_app_user_right_intro)
              ])),
          _createVNode(_component_app_opportunities_list_nav)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}